export default "__VITE_ASSET__2c80d35d__"